import { FetchPolicy } from '@constants/FetchPolicy';
import {
  GetAllClientsForVendor as GetAllClientsForVendorType,
  GetAllClientsForVendorVariables,
  getVendorForUser as GetVendorForUserType,
} from '@generated/types';

import { client, getData } from '..';
import { GetAllClientsForVendor } from '../_services/clients/queries';
import { GetVendorIdForUser } from '../_services/vendor/queries';
import { UserRoles } from '../constants/UserRoles';

export function isVendorUser() {
  return getData().loggedInUserRole === UserRoles.VENDOR;
}

export async function getMarketplaceWorkspaceIds(): Promise<Set<string>> {
  if (!isVendorUser()) {
    return new Set();
  }

  const { data: vendorData } = await client.query<GetVendorForUserType>({
    query: GetVendorIdForUser,
  });
  const vendorId = vendorData?.getVendorForUser?.id;

  if (!vendorId) {
    return new Set();
  }

  const { data: vendorClientsData } = await client.query<GetAllClientsForVendorType, GetAllClientsForVendorVariables>({
    query: GetAllClientsForVendor,
    variables: { vendorId },
    fetchPolicy: FetchPolicy.NETWORK_ONLY,
  });

  return new Set((vendorClientsData?.getAllClientsForVendor ?? []).map((vendorClient) => vendorClient.id));
}

export async function hasMarketplaceAccessInAnyWorkspace(): Promise<boolean> {
  if (!isVendorUser()) {
    return true;
  }

  return (await getMarketplaceWorkspaceIds()).size > 0;
}
